import axios, {AxiosInstance, AxiosResponse} from "axios"
import jwt_decode  from 'jwt-decode';

interface AuthToken {
  access_token: string,
  token_type: string,
  expirationDate: Date
}

class AxiosServiceHandler {
  private static axiosInstance: AxiosInstance;
  private static workingRequestsCount: number;
  refreshingToken = false;

  static getInstance() {
    return !this.axiosInstance
        ? this.createAxiosInstance()
        : this.axiosInstance;
  }

  static createAxiosInstance() {
    const _this = this;

    this.workingRequestsCount = 0;

    let axiosInstance = axios.create({
      // need to be changed, 60000 is correct
      timeout: 60000*5,
      // headers: {
      //   common: {
      //     "Access-Control-Allow-Origin": "*"
      //   }
      // }
    })

    axiosInstance.interceptors.request.use((config) => {
      return new Promise((resolve) => {
        let interval = setInterval(() => {
          if (_this.getWorkingRequestsCount() <= 6) {
            _this.addAWorkingRequest();
            clearInterval(interval)
            resolve(_this.promiseToSetAuthTokenToConfig(config))
            // resolve(_this.promiseToSetAuthToConfig(config))
          }
        }, 200)
      });
    }, (error) => {
      return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use((response) => {
      _this.removeAWorkingRequest()
      return Promise.resolve(response)
    }, (error) => {
      _this.removeAWorkingRequest()
      return Promise.reject(error)
    });

    return axiosInstance;
  }

  private static promiseToSetAuthTokenToConfig(config) {
    const _this = this;
    let jwtAuth = sessionStorage.getItem('jwtAuth');
    let refresh = sessionStorage.getItem('refresh');
    // if (false) {
    if (_this.isValidToken(jwtAuth)) {
      config.headers['Authorization'] = `Bearer ${jwtAuth}`;
      return Promise.resolve(config);
    } else if (_this.isValidToken(refresh)) {
      return _this.refreshToken()
        .then((tokenData) => {
          if (tokenData.data.error) {
            this.refreshingPromise = null;
            window.parent.postMessage({expired: true}, "*");
            return Promise.reject(config);
          } else {
            const {
              data: {
                access_token,
                refresh_token,
                id_token
              }
            } = tokenData;
            const actualJwtAuth = sessionStorage.getItem('jwtAuth');
            let actualRefresh = sessionStorage.getItem('refresh');
            const actualId = sessionStorage.getItem('id');
            if (actualJwtAuth !== access_token || actualRefresh !== refresh_token || actualId !== id_token) {
              _this.setToken(access_token);
              _this.setToken(refresh_token);
              _this.setToken(id_token);
              console.log(`Sending new token...`);
              window.parent.postMessage({access_token, refresh_token, id_token}, "*");
            }
            config.headers['Authorization'] = `Bearer ${access_token}`;
            return Promise.resolve(config);
          }
        }).finally(() => {
            this.refreshingPromise = null;
          });
    } else {
        console.log(`Warning that token has expired...`);
        window.parent.postMessage({expired: true}, "*");
        return Promise.reject(config);
    }
  }

  // token without refresh
  private static promiseToSetAuthToConfig(config) {
    let jwtAuth = sessionStorage.getItem('jwtAuth');
    if (jwtAuth) {
      const decodedToken = jwt_decode(jwtAuth);
      config.headers['Authorization'] = `${'Bearer'} ${jwtAuth}`;
    }
    return Promise.resolve(config);
  }

  private static isValidToken(jwtAuth) {
    let valid = false;
    if (jwtAuth) {
      const decodedToken: any = jwt_decode(jwtAuth);
      const expirationDate = new Date(decodedToken.exp * 1000);
      valid = jwtAuth && expirationDate >= new Date();
    }
    return valid;
  }

  static setToken(token) {
    let value = "";
    const decodedToken: any = jwt_decode(token);
    switch (decodedToken.typ.toLowerCase()) {
      case "id":
        value = 'id';
        break;
      case "refresh":
        value = 'refresh';
        break;
      case 'bearer':
      default:
        value = 'jwtAuth';
    }
    sessionStorage.setItem(value, token);
  }

  static getWorkingRequestsCount() {
    return this.workingRequestsCount;
  }

  static addAWorkingRequest() {
    this.workingRequestsCount = this.getWorkingRequestsCount() + 1;
  }

  static removeAWorkingRequest() {
    this.workingRequestsCount = Math.max(0, this.getWorkingRequestsCount() - 1);
  }

  private static async refreshToken() {
      if (!this.refreshingPromise) {
        // avvio il refresh del token
        console.log("WebGIS is requesting new Access Token");
        const refresh = sessionStorage.getItem('refresh');
        const postParams = new URLSearchParams();
        postParams.append('grant_type', "refresh_token");
        postParams.append('refresh_token', `${refresh}`);
        const config = {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        };
        this.refreshingPromise = axios.post(
            `${process.env.REACT_APP_DJANGO_HOME}${process.env.REACT_APP_DJANGO_TOKEN_ENDPOINT}`,
            postParams, config);
      }
      return this.refreshingPromise;
  }

  private static refreshingPromise: Promise<AxiosResponse<any>> | null;
}

export default AxiosServiceHandler;
